import { useRef } from 'react';
import { useEventListener } from 'usehooks-ts';

const useShortPress = <T extends HTMLElement>(
  popupRef: React.RefObject<T>,
  callback: () => void,
) => {
  const timerRef = useRef<number | null>(null);

  const onMouseDown = (event: MouseEvent) => {
    if (popupRef.current && !popupRef.current.contains(event.target as Node)) {
      timerRef.current = window.setTimeout(() => {
        timerRef.current = null;
      }, 300);
    }
  };

  const onMouseUp = (event: MouseEvent) => {
    if (
      timerRef.current &&
      popupRef.current &&
      !popupRef.current.contains(event.target as Node)
    ) {
      clearTimeout(timerRef.current);
      callback();
    }
  };

  useEventListener('mousedown', onMouseDown);
  useEventListener('mouseup', onMouseUp);
};

export default useShortPress;
